import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Wrench } from 'lucide-react';

interface MaintenanceModeProps {
  title?: string;
  description?: string;
}

export const MaintenanceMode = ({ 
  title = 'Portal temporariamente fora do ar',
  description = 'Estamos realizando correções e voltaremos em breve.'
}: MaintenanceModeProps) => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 "
      style={{ backgroundColor: '#F1EDDF' }}
    >
      <Card className="w-full max-w-lg shadow-2xl backdrop-blur-sm bg-white/90 border border-white/20">
        <CardHeader className="text-center space-y-4 pb-6">
          <div>
            <h1 
              className="text-3xl font-bold tracking-tight mb-1"
              style={{ color: '#10261F' }}
            >
              musa
            </h1>
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{ backgroundColor: '#10261F0D' }}>
              <Wrench className="w-7 h-7" style={{ color: '#10261F' }} />
            </div>
            <CardTitle 
              className="text-2xl font-semibold"
              style={{ color: '#10261F' }}
            >
              {title}
            </CardTitle>
            <CardDescription className="text-gray-600">
              {description}
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <div className="w-3 h-3 rounded-full bg-warning-500 animate-pulse" />
              <span>Em manutenção</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

